/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloExplorer as ApolloExplorerComponent } from '@apollo/explorer/react';
import { gql, useApolloClient } from '@apollo/client';
import introspection from '@slope/graphql/introspection.json' assert { type: 'json' };
import { IntrospectionQuery } from 'graphql';
import styled from 'styled-components';

const omitTypename = (data: any): any => {
  if (Array.isArray(data)) {
    return data.map(omitTypename);
  }
  if (data && typeof data === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { __typename, ...rest } = data;
    return Object.fromEntries(
      Object.entries(rest).map(([key, value]) => [key, omitTypename(value)]),
    );
  }
  return data;
};

const document = `
query Players {
  players {
    id
  }
}
`;
export const ApolloExplorer = styled((props) => {
  const client = useApolloClient();

  const handleRequest = async (_endpointUrl: string, options: Omit<RequestInit, 'headers'>) => {
    if (typeof options.body === 'string') {
      const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        operationName: _,
        query,
        variables,
      }: {
        operationName: string;
        query: string;
        variables: Record<string, string>;
      } = JSON.parse(options.body);

      const document = gql(query);

      let data: any;
      let errors: any;
      if (document.definitions.length > 1) {
        throw Error('Only 1 operation by queri allowed');
      }
      if (document.definitions[0].kind === 'OperationDefinition') {
        if (document.definitions[0].operation === 'mutation') {
          const queryResult = await client.mutate({
            mutation: document,
            variables,
          });
          data = queryResult.data;
          errors = queryResult.errors;
        } else if (document.definitions[0].operation === 'subscription') {
          // const queryResult = await client.subscribe({
          //   query: document,
          //   variables,
          // });
          // TODO
        } else {
          const queryResult = await client.query({
            query: document,
            variables,
          });
          data = queryResult.data;
          errors = queryResult.errors;
        }
      }

      const str = JSON.stringify(errors ? { errors } : { data: omitTypename(data) });

      const blob = new Blob([str], {
        type: 'application/json',
      });

      return new Response(blob, {
        status: 200,
      });
    }

    return new Response(
      new Blob(['str'], {
        type: 'application/json',
      }),
      {
        status: 500,
      },
    );
  };

  // Replace 'your-graph-ref' with your actual graphRef string
  return (
    <ApolloExplorerComponent
      schema={introspection as IntrospectionQuery}
      handleRequest={handleRequest}
      endpointUrl="not-implemented"
      persistExplorerState
      initialState={{
        document,
        displayOptions: {
          theme: 'light',
          showGlobalHeader: true,
        },
      }}
      {...props}
    />
  );
})`
  width: 100%;
  height: 100%;
`;
